import React, { useContext } from "react";
import CoinContext from "contexts/CoinContext";

import { setOrderTicketLite, setDiveBarCoin } from "store/actions";
import { map_coins, map_coin_to_name } from "store/constant";
import "styles/coins.css";
import colors from "assets/scss/_themes-vars.module.scss";
import useDiveBarSocket from "hooks/useDiveBarClubSocket";
import { useDispatch, useSelector } from "react-redux";

import {
  RESET_ALERT_TRENDING_BUY,
  RESET_ALERT_TRENDING_SELL,
} from "store/actions";

// material-ui
import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableSortLabel,
  TableRow,
  Typography,
  IconButton,
} from "@material-ui/core";

// material-ui
import { withStyles, makeStyles, useTheme } from "@material-ui/styles";
// import useSocket from "hooks/useSocket";

/*

    item.coin
    item.alerted
 */
// style constant
const useStyles = makeStyles((theme) => ({
  revenueCard: {
    position: "relative",
    color: "#fff",
  },
  revenueIcon: {
    position: "absolute",
    right: "13px",
    top: "14px",
    color: "#fff",
    "&> svg": {
      width: "100px",
      height: "100px",
      opacity: "0.5",
    },
    [theme.breakpoints.down("xs")]: {
      top: "13px",
      "&> svg": {
        width: "80px",
        height: "80px",
      },
    },
  },
  table: {
    border: 0,
    "table-layout": "fixed",
    width: "50%",
  },
  td: {
    border: "1px solid black",
    width: "50%",
    overflow: "hidden",
  },
}));

const CustomizedBadge = withStyles((theme) => ({
  badge: {
    right: -15,
    top: -15,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}))(Badge);

// table filter
function descendingComparator(a, b, orderBy) {
  if (orderBy !== "Pair") {
    if (Number(b[orderBy]) < Number(a[orderBy])) {
      return -1;
    }
    if (Number(b[orderBy]) > Number(a[orderBy])) {
      return 1;
    }
    return 0;
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  if (array === undefined) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// =============================|| REVENUE CARD ||============================= //

// table header
const headCells = [
  /*
  {
    id: "ts",
    numeric: false,
    disablePadding: false,
    label: "Time",
  },
  */
  {
    id: "Pair",
    numeric: false,
    disablePadding: true,
    label: "Pair",
  },
  /*
  {
    id: "invested",
    numeric: true,
    disablePadding: false,
    label: "Invested",
  },
  */
  {
    id: "last_trade",
    numeric: true,
    disablePadding: false,
    label: "Last Trade",
  },
  {
    id: "level_percent",
    numeric: true,
    disablePadding: false,
    label: "Profit(%)",
  },
  {
    id: "open_price",
    numeric: true,
    disablePadding: false,
    label: "Average",
  },
  {
    id: "ltp",
    numeric: true,
    disablePadding: false,
    label: "LTP",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: "#191b1e" }}>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "left" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
const SummarizedTable = ({ type, items }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("level_percent");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const [selectedIndex, setSelectedIndex] = React.useState("0");
  const { setCoin } = useContext(CoinContext);


  const { userMsg } = useDiveBarSocket();
  const { openedRoom } = useSelector((state) => state.diveBarClub);

  const { ohlcInterval } = useSelector((state) => state.diveBarChart);


  const setDivebarCoin = (coin) => {
    dispatch(setDiveBarCoin(coin));

    if (openedRoom) {
      userMsg(
        JSON.stringify({
          type: "transport_message",
          interval: `${ohlcInterval}`,
          coin,
        }),
        openedRoom.roomId
      );
    }

  };

  const theme = useTheme();

  const green =
    theme.palette.mode === "dark"
      ? colors.successLightTakyon
      : colors.successDarkTakyon;
  const red =
    theme.palette.mode === "dark"
      ? colors.errorLightTakyon
      : colors.errorDarkTakyon;

  const handleListItemClick = (event, coin, total) => {
    // setSelectedIndex(coin);
    setCoin(coin);
    setDivebarCoin(coin);
    // fetchOHLC(coin, ohlcInterval); // default interval
    // fetchBalance();
    // TMD console.log({ type });
    // Let's reset the alert for this coin.

    const tab = type === "TrendingBuy" ? 1 : 0;
    const qty = type === "TrendingBuy" ? total : 0;
    dispatch(setOrderTicketLite(tab, qty));

    if (type === "TrendingBuy") {
      dispatch({ type: RESET_ALERT_TRENDING_BUY, payload: { coin: coin } });
    } else if (type === "TrendingSell") {
      dispatch({ type: RESET_ALERT_TRENDING_SELL, payload: { coin: coin } });
    }
  };

    // TMD console.log( '------SAMEER SUMMARIZED_TABLE ----');
    // TMD console.log(items);
  return (
    <TableContainer className={classes.container}>
      <Table sx={{ width: "100%" }} size="small" aria-label="LiqPortfolio">
        <EnhancedTableHead
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {items !== undefined &&
            stableSort(items, getComparator(order, orderBy)).map(
              (row, index) => {
                const coin_style = map_coins.get(row.coin);
                const coin_name = map_coin_to_name.get(row.coin)
                  ? map_coin_to_name.get(row.coin)
                  : row.coin;
                const mrung = row.move === "↓↓↓" ? red : green;
                const rung = row.level_percent < 0.0 ? red : green;
                // const labelId = `${row.coin}`;
                const alertCount = row.alerted ? 1 : 0;
                // const ts = new Date(row.ts).toLocaleTimeString();
                // TMD console.log( 'SAMEER3    trending SUMMARIZED TABLE');
                const day_2_diff = (row.ltp - row.day_2_high);
                const day_2_percent = day_2_diff * 100.0 / row.day_2_high;
                let trung = (row.ltp > row.open_price) ? green : red;
                if ( type === "TrendingSell")
                {
                    trung = (row.ltp > row.open_price) ? red : green;
                }

                // TMD console.log( coin_name + ', day2: ' + day_2_diff + ', percent: ' + day_2_percent);


                return (
                  <TableRow
                    hover
                    role="checkbox"
                    key={row.coin}
                    // onClick={(event) => handleListItemClick(event, row.coin, row.last_trade)}
                    //qty for sell side
                    onClick={(event) =>
                      handleListItemClick(event, row.coin, row.qty)
                    }
                  >
                    {/*
                                    <TableCell>
                                        <Typography variant="subtitle1" sx={{ fontSize: "0.9rem", textAlign: "left", color: "white", }} >
                                            {ts}
                                        </Typography>
                                    </TableCell>
                                    */}
                    <TableCell>
                      <table
                        style={{
                          fixed: { "table-layout": "fixed" },
                          td: { overflow: "hidden" },
                        }}
                      >
                        <tr>
                          <td style={{ align: "left" }}>
                            <a className={coin_style}> {coin_name} </a>
                          </td>
                          <td>
                        {row.move}
                        {"    "}
                        {alertCount === 1 && (
                          <IconButton aria-label="cart">
                            <CustomizedBadge
                              badgeContent={alertCount}
                              color="error"
                            />
                          </IconButton>
                        )}
                          </td>
                        </tr>
                      </table>
                    </TableCell>

                    <TableCell sx={{ color: trung }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: "0.9rem",
                          textAlign: "left",
                          color: trung,
                        }}
                      >
                        ${row.last_trade.toFixed(2)}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ color: trung }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: "0.9rem",
                          textAlign: "left",
                          color: trung,
                        }}
                      >
                        {row.level_percent.toFixed(2)}%{" "}{row.qty}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ color: trung }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: "0.9rem",
                          textAlign: "left",
                          color: trung,
                        }}
                      >
                        {(row.open_price !== undefined) && row.open_price.toFixed(2)}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ color: trung }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: "0.9rem",
                          textAlign: "left",
                          color: trung,
                        }}
                      >
                        {(row.ltp !== undefined) && row.ltp.toFixed(2)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              }
            )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SummarizedTable.propTypes = {};

export default React.memo(SummarizedTable);
